import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { TranslationContext } from "@is/constants";
import { ScannerContext } from "@is/contexts/ScannerContext";

function useManageSelectScannerModal() {
  const { t } = useTranslation(TranslationContext.Settings);
  const { scannerName, handleSelectScanner, handleDisconnectScanner } =
    useContext(ScannerContext);

  return { handleSelectScanner, handleDisconnectScanner, scannerName, t };
}

export default useManageSelectScannerModal;
